






















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { Review, ReviewType, LearnerReviews } from "../../types";
import moment from "moment";

@Component({
  filters: {
    moment: (date: string) => {
      return moment(date).format("MM/DD/YYYY");
    }
  }
})
export default class LearnerReviewsTab extends Vue {
  @Getter private learnerReviews!: LearnerReviews[];
  @Action private fetchLearnerReviews: any;

  private tableHeaderColor = "#eafbff";
  private currentPage: number = 1;
  private totalRows: number = 0;
  private isLoading = true;
  private headVariant: string = "item";

  private fields: any = [
    {
      key: "title",
      label: "Title",
      sortable: false
    },
    {
      key: "view",
      label: "",
      sortable: false
    }
  ];

  private created() {
    if (this.learnerReviews != null && this.learnerReviews.length > 0) {
      this.onLearnerReviews();
    }
    
    this.fetchLearnerReviews();
  }

  @Watch("learnerReviews")
  private onLearnerReviews() {
    this.isLoading = false;
  }

  private rowClicked(item: LearnerReviews) {
    this.$router.push({
      name: "reviewedSession",
      params: {
        userFromLearner: "true",
        sessionID: item.sid
      }
    });
  }
}
